import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { Skeleton } from '../../../components/ui/skeleton';
import { FileText, FileSearch, RefreshCw } from 'lucide-react';
import { SemaforoBadge } from './Badges';
import { fmtDate, getSemaforo } from '../utils';

export function BandejaList({ items, loading, onSelect, selectedId, onRefresh }) {
  return (
    <div className="border rounded-lg bg-card overflow-hidden">
      <div className="px-3 py-2 border-b bg-muted/30 flex items-center justify-between">
        <div className="text-sm font-medium flex items-center gap-2">
          <FileSearch className="w-4 h-4" /> Bandeja ({items.length})
        </div>
        <Button size="sm" variant="ghost" onClick={onRefresh} data-testid="btn-refresh-bandeja">
          <RefreshCw className="w-3.5 h-3.5" />
        </Button>
      </div>
      <div className="max-h-[70vh] overflow-y-auto">
        {loading && (
          <div className="p-3 space-y-2">
            {[...Array(4)].map((_, i) => <Skeleton key={i} className="h-14 w-full" />)}
          </div>
        )}
        {!loading && items.length === 0 && (
          <div className="p-6 text-center text-sm text-muted-foreground">
            <FileText className="w-6 h-6 mx-auto mb-2 opacity-40" />
            No hay conciliaciones aún.
          </div>
        )}
        {!loading && items.map((it) => {
          const semaforo = getSemaforo(it);
          const isSelected = it.id === selectedId;
          return (
            <button
              key={it.id}
              onClick={() => onSelect(it)}
              data-testid={`bandeja-item-${it.id}`}
              className={`w-full text-left px-3 py-2.5 border-b hover:bg-muted/50 transition-colors ${isSelected ? 'bg-muted/70 border-l-4 border-l-primary' : ''}`}
            >
              <div className="flex items-start justify-between gap-2 mb-1">
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate" title={`${it.proveedor_nombre || ''}\nRUT: ${it.proveedor_rut || '—'}`}>
                    {it.proveedor_nombre || '(sin proveedor)'}
                  </div>
                  <div className="text-[11px] text-muted-foreground truncate flex items-center gap-1.5">
                    {/* Iter 235.c (Carlos): mostrar RUT visible para distinguir proveedores con nombres similares */}
                    {it.proveedor_rut && (
                      <span className="font-mono text-[10px] bg-slate-100 px-1 rounded">
                        {it.proveedor_rut}
                      </span>
                    )}
                    <span className="truncate" title={it.filename}>{it.filename}</span>
                  </div>
                </div>
                <SemaforoBadge color={semaforo} size="sm" />
              </div>
              <div className="flex items-center justify-between text-[11px] text-muted-foreground">
                <span>{fmtDate(it.uploaded_at)}</span>
                <span className="flex items-center gap-2">
                  {(it.totales?.faltante || 0) > 0 && <span className="text-red-600 font-medium">F:{it.totales.faltante}</span>}
                  {(it.totales?.match_parcial || 0) > 0 && <span className="text-amber-600 font-medium">P:{it.totales.match_parcial}</span>}
                  {(it.totales?.match_perfecto || 0) > 0 && <span className="text-emerald-700">✓:{it.totales.match_perfecto}</span>}
                </span>
              </div>
              {(() => {
                const faltFolios = (it.matching || [])
                  .filter((m) => m.estado === 'faltante')
                  .map((m) => m.folio_proveedor || 's/folio');
                if (faltFolios.length === 0) return null;
                return (
                  <div className="mt-0.5 text-[10px] text-red-600 truncate" data-testid={`bandeja-faltantes-${it.id}`}>
                    Factura(s) faltante(s): {faltFolios.slice(0, 3).join(', ')}{faltFolios.length > 3 ? ` +${faltFolios.length - 3} más` : ''}
                  </div>
                );
              })()}
              {it.estado && it.estado !== 'pendiente_revision' && (
                <div className="mt-1">
                  <Badge variant="outline" className="text-[10px] py-0">
                    {it.estado === 'resuelta' ? '🔒 Resuelta (100% pagado)'
                      : it.estado === 'aprobada' ? (it.auto_aprobada ? '✓ Aprobada (auto)' : '✓ Aprobada')
                      : it.estado === 'rechazada' ? '✗ Rechazada'
                      : it.estado === 'superada' ? '⟲ Superada (reemplazada)'
                      : it.estado === 'reenviado_corporativo' ? '📤 Reenviado a corporativo'
                      : it.estado}
                  </Badge>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
